(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rainshadow-seat-map-ex"] && !Shopify.designMode) return;
  try {
    

const sectionControllers = new Map();
let loading = false;
document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);

function init() {
  if (loading) return;
  loading = true;
  const sections = document.querySelectorAll('.rs-seat-map[data-ex]') || [];
  sections.forEach(section => {
    if (!section) return;
    
    const abort = sectionControllers.get(section.id);
    if (abort) {
      abort.controller.abort();
      clearInterval(abort.section._rsRefreshTimer);
      abort.section._rsTooltip?.remove();
    }
    const controller = new AbortController();
    const { signal } = controller;
    sectionControllers.set(section.id, {
      controller,
      section
    });

    const wrapper      = section.querySelector('.rs-seat-map-wrapper');
    const viewport     = section.querySelector('.rs-seat-map-viewport');
    const container    = section.querySelector('.rs-seat-map-container');
    const selectedList = section.querySelector('.rs-selected-list');
    const totalPrice   = section.querySelector('.rs-price-total');
    const buyButton    = section.querySelector('.rs-purchase-button');
    const loadingEl    = section.querySelector('.rs-loading-indicator');
    const loadingText  = section.querySelector('.rs-loading-text');
    const limitMsgEl   = section.querySelector('.rs-limit-message');
    const cacheKey = section.id;
    let cacheVer = 0;

    const cfg       = JSON.parse(section.querySelector('.rs-seat-config').textContent);
    const s         = cfg.settings;
    const inCart = cfg.inCartIds.map(String);

    let allVariants = []; // parsed {id, title, price, qty, metafieldOffset, row, col}
    let quantities  = {}; // id → live qty
    let selected    = []; // selected variant id strings
    let maxRow = 0, maxCol = 0;

    function money(cents) {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency', currency: Shopify.currency.active,
      });
    }

    function isLimitActive() {
      return s.maxPerCart > 0 && selected.length >= s.maxPerCart;
    }

    function formatLimitMessage() {
      return (s.limitMessage || '')
        .replace(messageKeyword('max'), String(s.maxPerCart));
    }

    function updateLimitState() {
      const atLimit = isLimitActive();
      section.classList.toggle('rs-limit-reached', atLimit && s.maxPerCart > 0);
      if (!limitMsgEl) return;
      if (atLimit) {
        const text = formatLimitMessage();
        limitMsgEl.textContent = text;
        limitMsgEl.style.display = text === '' ? 'none' : '';
      } else {
        limitMsgEl.style.display = 'none';
      }
    }

    let tooltipEl = null;
    if (s.tooltipEnable) {
      tooltipEl = document.createElement('div');
      tooltipEl.className = 'rs-tooltip';
      document.body.appendChild(tooltipEl);
      section._rsTooltip = tooltipEl;
    }

    function messageKeyword(word) {
      return new RegExp(`(\\{|&lcub;)\\s*${word}\\s*(\\}|&rcub;)`, 'g');
    }

    function formatTooltip(v) {
      const {row, col} = v;
      const qty = quantities[v.id] ?? v.qty;
      if (isLimitActive() && !selected.includes(String(v.id)) && qty > 0) {
        const message = formatLimitMessage();
        if (message) return message;
      }
      return (s.tooltipTemplate || '{ title }')
        .replace(messageKeyword('title'), v.title.replace(/\$/g, '$$$$'))
        .replace(messageKeyword('price'), money(v.price).replace(/\$/g, '$$$$'))
        .replace(messageKeyword('row'),   String(row))
        .replace(messageKeyword('col'),   String(col))
        .replace(messageKeyword('qty'),   String(qty));
    }

    function showTooltip(text, e) {
      if (!tooltipEl) return;
      tooltipEl.innerHTML = text;
      tooltipEl.style.display = 'block';
      positionTooltip(e);
    }

    function hideTooltip() {
      if (!tooltipEl) return;
      tooltipEl.style.display = 'none';
    }

    function positionTooltip(e) {
      if (!tooltipEl) return;
      const pad  = 12;
      const tw   = tooltipEl.offsetWidth;
      const th   = tooltipEl.offsetHeight;
      const vw   = window.innerWidth;
      const vh   = window.innerHeight;
      let x = e.clientX + pad;
      let y = e.clientY + pad;
      if (x + tw > vw - pad) x = e.clientX - tw - pad;
      if (y + th > vh - pad) y = e.clientY - th - pad;
      tooltipEl.style.left = x + 'px';
      tooltipEl.style.top  = y + 'px';
    }

    const ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    function toLabel(num, alphabetical) {
      if (!alphabetical) return String(num);
      let n = num, label = '';
      while (n > 0) {
        label = ALPHA[(n - 1) % 26] + label;
        n = Math.floor((n - 1) / 26);
      }
      return label;
    }

    function parseVariant(v) {
      const parts = v.title.split(' - ');
      const row   = parseInt((parts[2] || '').split(' ').pop()) || 0;
      const col   = parseInt((parts[3] || '').split(' ').pop()) || 0;
      return { ...v, row, col };
    }

    function parseCsv(str) {
      if (!str) return [];
      return str.split(',').map(group => {
        const ci = group.indexOf(':');
        const coordPart = ci === -1 ? group : group.slice(0, ci);
        const gOffset   = ci === -1 ? 1 : parseInt(group.slice(ci + 1)) || 1;
        const xi = coordPart.indexOf('x');
        const gRow = xi === -1 ? parseInt(coordPart) || 0 : parseInt(coordPart.slice(0, xi)) || 0;
        const gCol = xi === -1 ? 1 : parseInt(coordPart.slice(xi + 1)) || 1;
        return { gRow, gCol, gOffset };
      });
    }
    const csvEntries = parseCsv(s.offsetCsv);

    function computeOffset(origRow, displayCol) {
      let offset = 0;
      const method = s.offsetMethod || '';

      if (method === 'metafield' || method === 'both') {
        for (const other of allVariants) {
          if (other.row !== origRow || !other.metafieldOffset) continue;
          const otherDisplayCol = s.reverseCols ? maxCol - other.col + 1 : other.col;
          if (s.reverseRows ? otherDisplayCol <= displayCol : otherDisplayCol >= displayCol) {
            offset += other.metafieldOffset;
          }
        }
      }

      if (method === 'csv' || method === 'both') {
        for (const { gRow, gCol, gOffset } of csvEntries) {
          if (gRow !== origRow) continue;
          if (s.reverseRows ? gCol <= displayCol : gCol >= displayCol) {
            offset += gOffset;
          }
        }
      }

      return offset;
    }

    function recomputeMaxes() {
      maxRow = 0; maxCol = 0;
      for (const v of allVariants) {
        if (v.row > maxRow) maxRow = v.row;
        if (v.col > maxCol) maxCol = v.col;
      }

      const useCsv  = s.offsetMethod === 'csv'       || s.offsetMethod === 'both';
      const useMeta = s.offsetMethod === 'metafield'  || s.offsetMethod === 'both';

      if (useCsv || useMeta) {
        for (let r = 1; r <= maxRow; r++) {
          let maxInRow = 0, rowOffset = 0;

          for (const v of allVariants) {
            if (v.row !== r) continue;
            if (v.col > maxInRow) maxInRow = v.col;
            if (useMeta && v.metafieldOffset) rowOffset += v.metafieldOffset;
          }

          if (useCsv) {
            for (const { gRow, gOffset } of csvEntries) {
              if (gRow === r) rowOffset += gOffset;
            }
          }

          const effective = maxInRow + rowOffset;
          if (effective > maxCol) maxCol = effective;
        }
      }
    }

    function renderMap() {
      wrapper.innerHTML = '';

      if (s.showColumnLabels) {
        const halfW = s.seatWidth / 2;
        for (let col = 1; col <= maxCol; col++) {
          const el = document.createElement('div');
          el.className   = 'rs-column-label rs-seat-label';
          el.style.left  = ((col - 1) * s.spacingCol + halfW) + 'px';
          el.style.top   = -s.labelPadding-s.labelSize + 'px';
          el.textContent = toLabel(s.reverseCols ? maxCol - col + 1 : col, s.alphabeticalCols);
          wrapper.appendChild(el);
        }
      }

      if (s.showRowLabels) {
        const halfH = s.seatHeight / 2;
        for (let row = 1; row <= maxRow; row++) {
          const el = document.createElement('div');
          el.className   = 'rs-row-label rs-seat-label';
          el.style.top   = ((row - 1) * s.spacingRow + halfH) + 'px';
          el.style.left  = -s.labelPadding-s.labelSize + 'px';
          el.textContent = toLabel(s.reverseRows ? maxRow - row + 1 : row, s.alphabeticalRows);
          wrapper.appendChild(el);
        }
      }

      for (const v of allVariants) {
        if (!v.row || !v.col) continue;

        const displayCol = s.reverseCols ? maxCol - v.col + 1 : v.col;
        const displayRow = s.reverseRows ? maxRow - v.row + 1 : v.row;
        const offset     = computeOffset(v.row, displayCol);
        const cx         = (displayCol + offset - 1) * s.spacingCol;
        const cy         = (displayRow - 1) * s.spacingRow;
        const qty        = quantities[v.id] ?? v.qty;

        const el = document.createElement('div');
        el.className =
          'rs-seat' +
          (qty === 0                       ? ' rs-sold'     : '') +
          (selected.includes(String(v.id)) ? ' rs-selected' : '');
        el.dataset.variantId = v.id;
        el.dataset.title     = v.title;
        el.dataset.price     = v.price;
        el.dataset.quantity  = qty;
        el.style.top         = cy + 'px';
        el.style.left        = cx + 'px';
        el.addEventListener('click', onSeatClick);

        if (s.tooltipEnable) {
          el.addEventListener('mouseenter', e => showTooltip(formatTooltip(v), e));
          el.addEventListener('mousemove',  e => positionTooltip(e));
          el.addEventListener('mouseleave', hideTooltip);
        }

        wrapper.appendChild(el);
      }

      const W = maxCol * s.spacingCol;
      const H = maxRow * s.spacingRow;
      const labelOffsetLeft = s.showRowLabels    && s.labelPadding > 0 ? s.labelPadding + s.labelSize : 0;
      const labelOffsetTop  = s.showColumnLabels && s.labelPadding > 0 ? s.labelPadding + s.labelSize : 0;

      section.style.setProperty('--rs-label-offset-left', labelOffsetLeft + 'px');
      section.style.setProperty('--rs-label-offset-top',  labelOffsetTop  + 'px');
      section.style.setProperty('--rs-wrapper-width', W + 'px');
      section.style.setProperty('--rs-wrapper-height',  H  + 'px');
      wrapper.style.width  = W + 'px';
      wrapper.style.height = H + 'px';

      viewport.dataset.defaultWidth    = W;
      viewport.dataset.defaultHeight   = H;
      viewport.dataset.labelOffsetLeft = labelOffsetLeft;

      layoutSeatMap();
      renderSelectedPanel();
    }

    function onSeatClick(e) {
      const el = e.currentTarget;
      const id = String(el.dataset.variantId);
      if (selected.includes(id)) {
        selected = selected.filter(x => x !== id);
        el.classList.remove('rs-selected');
      } else {
        if (s.maxPerCart > 0 && selected.length >= s.maxPerCart) return;
        if (el.dataset.quantity < 1) return;
        selected.push(id);
        el.classList.add('rs-selected');
      }
      renderSelectedPanel();
    }

    function renderSelectedPanel() {
      updateLimitState();

      selectedList.innerHTML = '';
      let total = 0;
      const valid = [],
        rows = [];

      for (const id of selected) {
        const seatEl   = wrapper.querySelector(`[data-variant-id="${id}"]`);
        if (!seatEl) continue;
        const qty      = quantities[id] ?? parseInt(seatEl?.dataset.quantity ?? 0);
        const priceVal = parseInt(seatEl?.dataset.price ?? 0);

        const row  = document.createElement('div');
        row.className = 'rs-selected-list-item';

        const info = document.createElement('div'),
          text = seatEl?.dataset.title ?? id;
        info.className = 'rs-selected-ticket-info';
        info.appendChild(Object.assign(document.createElement('span'), { textContent: text }));
        info.appendChild(Object.assign(document.createElement('span'), { textContent: money(priceVal) }));

        const removeBtn = document.createElement('button');
        removeBtn.className = 'rs-selected-remove';
        removeBtn.type = 'button';
        removeBtn.setAttribute('aria-label', 'Remove ticket');
        removeBtn.innerHTML = '&times;';
        removeBtn.addEventListener('click', e => {
          e.stopPropagation();
          selected = selected.filter(x => x !== id);
          seatEl?.classList.remove('rs-selected', 'rs-unavailable-selected');
          renderSelectedPanel();
        });

        if (qty === 0) {
          info.classList.add('strike');
          seatEl?.classList.add('rs-unavailable-selected');
        } else {
          total += priceVal;
          valid.push(id);
          seatEl?.classList.remove('rs-unavailable-selected');
        }

        row.appendChild(info);
        row.appendChild(removeBtn);
        rows.push({ text, row });
      }

      rows.sort((a, b) => (a.text || '').localeCompare(b.text));
      rows.forEach(row => selectedList.appendChild(row.row));

      if (valid.length) {
        buyButton.removeAttribute('disabled');
        buyButton.href = '/cart/' + valid.map(id => `${id}:1`).join(',');
      } else {
        buyButton.setAttribute('disabled', 'true');
        buyButton.removeAttribute('href');
      }
      totalPrice.textContent = total ? 'Total: ' + money(total) : '';
    }

    function layoutSeatMap() {
      const rotateStr = (section.dataset.rotate || '0deg').trim();
      const W = parseFloat(viewport.dataset.defaultWidth  || 0);
      const H = parseFloat(viewport.dataset.defaultHeight || 0);
      if (!W || !H) return;

      let rad = 0;
      if      (rotateStr.endsWith('turn')) rad = parseFloat(rotateStr) * 2 * Math.PI;
      else if (rotateStr.endsWith('rad'))  rad = parseFloat(rotateStr);
      else if (rotateStr.endsWith('grad')) rad = parseFloat(rotateStr) * Math.PI / 200;
      else                                  rad = parseFloat(rotateStr) * Math.PI / 180;

      const labelOffset = 2 * parseFloat(viewport.dataset.labelOffsetLeft || 0);
      const cos = Math.abs(Math.cos(rad)), sin = Math.abs(Math.sin(rad));
      const rotatedW = W * cos + H * sin + labelOffset;
      const rotatedH = W * sin + H * cos;

      let scale = 1;
      if (s.scaleEnabled) {
        scale = Math.min(container.clientWidth / rotatedW, s.scaleMax);
        scale = Math.max(scale, s.scaleMin);
      }

      viewport.style.width  = (rotatedW * scale) + 'px';
      viewport.style.height = (rotatedH * scale) + 'px';
      wrapper.style.position   = 'absolute';
      wrapper.style.left       = '50%';
      wrapper.style.top        = '50%';
      wrapper.style.marginLeft = (-W / 2) + 'px';
      wrapper.style.marginTop  = (-H / 2) + 'px';
      wrapper.style.transform  = `rotate(${rotateStr}) scale(${scale})`;
    }

    window.addEventListener('resize', layoutSeatMap, { signal });

    function fetchVariantPage(pageNum) {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', cfg.sectionId);
      url.searchParams.set('page', pageNum);
      url.searchParams.set('v', cacheKey + ++cacheVer);
      return fetch(url)
        .then(r => {
          if (!r.ok) throw new Error(`HTTP ${r.status} on page ${pageNum}`);
          return r.text();
        })
        .then(html => new DOMParser().parseFromString(html, 'text/html'))
        .then(html => html.body.querySelector('#rs-variant-data').textContent.trim())
        .then(text => JSON.parse(text));
    }

    const refreshInterval = parseInt(section.dataset.refreshInterval);
    if (refreshInterval > 0 && !Shopify.designMode) {
      async function refreshQuantities() {
        try {
          const page1Url = new URL(window.location.href);
          page1Url.searchParams.set('section_id', section.dataset.refreshSection);
          page1Url.searchParams.set('v', cacheKey + ++cacheVer);

          const page1Html = await fetch(page1Url).then(r => r.text());
          const doc = new DOMParser().parseFromString(page1Html, 'text/html');
          const page1Variants = JSON.parse(
            doc.querySelector('.rs-seat-page-variants')?.textContent || '[]'
          );

          const extraPages = cfg.totalPages > 1
            ? await Promise.all(
                Array.from({ length: cfg.totalPages - 1 }, (_, i) => fetchVariantPage(i + 2))
              )
            : [];

          const allFresh = [page1Variants, ...extraPages].flat();
          for (const v of allFresh) quantities[v.id] = v.qty;

          wrapper.querySelectorAll('.rs-seat').forEach(el => {
            const qty = quantities[el.dataset.variantId] ?? parseInt(el.dataset.quantity);
            el.classList.toggle('rs-sold', qty === 0);
            el.dataset.quantity = qty;
          });

          renderSelectedPanel();
        } catch (err) {
          console.error('[RS Seat Map] Quantity refresh failed:', err);
        }
      }

      section._rsRefreshTimer = setInterval(refreshQuantities, refreshInterval * 1000);
    }

    async function loadAllVariants() {
      const page1 = JSON.parse(
        section.querySelector('.rs-seat-page-variants').textContent
      ).map(parseVariant);

      for (const v of page1) quantities[v.id] = v.qty;
      allVariants = page1;
      selected = selected.concat(inCart)
        .filter((e, i, a) => a.indexOf(e) === i);
      if (s.maxPerCart > 0 && selected.length > s.maxPerCart) {
        selected = selected.slice(0, s.maxPerCart);
      }
      recomputeMaxes();
      renderMap();

      if (cfg.totalPages <= 1) return;

      loadingEl.style.display = 'flex';
      loadingText.textContent = 'Loading seats…';

      const pageNums = Array.from({ length: cfg.totalPages - 1 }, (_, i) => i + 2);

      try {
        const pages = await Promise.all(pageNums.map(fetchVariantPage));
        for (const pageVariants of pages) {
          const parsed = pageVariants.map(parseVariant);
          for (const v of parsed) quantities[v.id] = v.qty;
          allVariants = allVariants.concat(parsed);
        }
        recomputeMaxes();
        renderMap();
        loadingEl.style.display = 'none';
      } catch (err) {
        console.error('[RS Seat Map] Failed to load additional variant pages:', err);
        loadingText.textContent = 'Could not load all seats — showing first 250.';
      }
    }

    loadAllVariants();
  });

  loading = false;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rainshadow-seat-map"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);

function init() {
  const section = document.querySelector('.rs-seat-map[data-base]');
  if (!section) return;

  const wrapper = section.querySelector('.rs-seat-map-wrapper');
  const viewport = section.querySelector('.rs-seat-map-viewport');
  const container = section.querySelector('.rs-seat-map-container');
  const seats = [...section.querySelectorAll('.rs-seat')];
  const selectedList = section.querySelector('.rs-selected-list');
  const perPrice = section.querySelector('.rs-price-per');
  const totalPrice = section.querySelector('.rs-price-total');
  const buyButton = section.querySelector('.rs-purchase-button');

  let quantities = JSON.parse(section.querySelector('.rs-seat-quantities').textContent);
  let selected = seats.filter((s) => s.classList.contains('rs-selected')).map((s) => s.dataset.variantId);

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: Shopify.currency.active,
    });
  }

  function render(){
    selectedList.innerHTML = '';
    let total = 0;
    let valid = [];

    selected.forEach(id =>{
      const seat = seats.find(s => s.dataset.variantId === id);
      if(!seat) return;

      const qty = quantities[id] ?? 0;

      const row = document.createElement('div');
      row.className = 'rs-selected-list-item';
      row.dataset.variantId = id;

      const info = document.createElement('div');
      info.className = 'rs-selected-ticket-info';

      const name = document.createElement('span');
      name.textContent = seat.dataset.title;

      const price = document.createElement('span');
      price.textContent = money(parseInt(seat.dataset.price));

      info.appendChild(name);
      info.appendChild(price);

      const removeBtn = document.createElement('button');
      removeBtn.className = 'rs-selected-remove';
      removeBtn.type = 'button';
      removeBtn.setAttribute('aria-label', 'Remove ticket');
      removeBtn.innerHTML = '&times;';

      removeBtn.addEventListener('click', (e) => {
        e.stopPropagation();

        selected = selected.filter(x => x !== id);
        seat.classList.remove('rs-selected');
        seat.classList.remove('rs-unavailable-selected');

        render();
      });

      row.appendChild(info);
      row.appendChild(removeBtn);

      if(qty == 0){
        info.classList.add('strike');
        seat.classList.add('rs-unavailable-selected');
      } else {
        total += parseInt(seat.dataset.price);
        valid.push(id);
        seat.classList.remove('rs-unavailable-selected');
      }

      selectedList.appendChild(row);
    });

    if(valid.length){
      buyButton.removeAttribute('disabled');
      buyButton.href = '/cart/'+valid.map(id =>`${id}:1`).join(',');
    } else {
      buyButton.setAttribute('disabled','true');
      buyButton.removeAttribute('href');
    }

    totalPrice.textContent = total ? "Total: "+money(total) : "";
  }

  seats.forEach((seat) => {
    if (seat.classList.contains('rs-sold')) return;
    seat.addEventListener('click', () => {
      const id = seat.dataset.variantId;
      if (selected.includes(id)) {
        selected = selected.filter((x) => x !== id);
        seat.classList.remove('rs-selected');
      } else {
        selected.push(id);
        seat.classList.add('rs-selected');
      }
      render();
    });
  });

  function layoutSeatMap() {
    const rotateStr = (section.dataset.rotate || '0deg').trim();
    const scaleEnabled = 'scale' in viewport.dataset;
    const minScale = scaleEnabled ? parseFloat(viewport.dataset.scaleMin || 0.5) : 1;
    const maxScale = scaleEnabled ? parseFloat(viewport.dataset.scaleMax || 2) : 1;

    const W = parseFloat(viewport.dataset.defaultWidth);
    const H = parseFloat(viewport.dataset.defaultHeight);
    if (!W || !H) return;

    let angleRad = 0;
    if (rotateStr.endsWith('turn')) {
      angleRad = parseFloat(rotateStr) * 2 * Math.PI;
    } else if (rotateStr.endsWith('rad')) {
      angleRad = parseFloat(rotateStr);
    } else if (rotateStr.endsWith('grad')) {
      angleRad = parseFloat(rotateStr) * Math.PI / 200;
    } else {
      angleRad = parseFloat(rotateStr) * Math.PI / 180;
    }

    const labelOffset = 2 * parseFloat(viewport.dataset.labelOffsetLeft || 0);
    const cos = Math.abs(Math.cos(angleRad));
    const sin = Math.abs(Math.sin(angleRad));
    const rotatedW = W * cos + H * sin + labelOffset;
    const rotatedH = W * sin + H * cos;

    let scale = 1;
    if (scaleEnabled) {
      scale = Math.min(container.clientWidth / rotatedW, maxScale);
      scale = Math.max(scale, minScale);
    }

    viewport.style.width  = (rotatedW * scale) + 'px';
    viewport.style.height = (rotatedH * scale) + 'px';

    wrapper.style.position = 'absolute';
    wrapper.style.left = '50%';
    wrapper.style.top = '50%';

    wrapper.style.marginLeft = (-W / 2) + 'px';
    wrapper.style.marginTop  = (-H / 2) + 'px';
    wrapper.style.transform  = `rotate(${rotateStr}) scale(${scale})`;
  }

  layoutSeatMap();
  window.addEventListener('resize', layoutSeatMap);

  const interval = parseInt(section.dataset.refreshInterval);
  if (interval > 0 && !Shopify.designMode) {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', section.dataset.refreshSection);
    setInterval(() => {
      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newData = doc.querySelector('.rs-seat-quantities');
          if (!newData) return;
          quantities = JSON.parse(newData.textContent);

          seats.forEach((seat) => {
            const id = seat.dataset.variantId;
            const qty = quantities[id] ?? 0;
            seat.classList.toggle('rs-sold', qty === 0);
          });

          render();
        });
    }, interval * 1000);
  }

  render();
}

  } catch(e) { console.error(e); }
})();
})();
